import React from 'react';

import type * as api from '@gitbook/api-client';
import type * as analytics from '@gitbook/app-analytics/client';
import type { NavigationScreenSpaceState } from '@gitbook/app-navigation';
import {
    BreadcrumbsSkeleton,
    HeaderBar,
    HeaderBarBreadcrumbs,
    HeaderBarMain,
    HeaderBarTabs,
} from '@gitbook/spine-react';

import { TableOfContentsMobileToggleButton } from '../TableOfContents';
import { BreadcrumbsRevision } from './BreadcrumbsRevision';
import { ViewModeButton } from './ViewModeButton';

/**
 * Header when viewing a revision.
 */
export function HeaderRevision(props: {
    screen: NavigationScreenSpaceState;
    space: api.Space;
    changeRequest: api.ChangeRequest | null;
    analyticsContext: analytics.AnalyticsContextSpaceContent;
}) {
    const { screen, space, changeRequest } = props;

    return (
        <HeaderBar>
            <HeaderBarMain>
                <TableOfContentsMobileToggleButton />

                <HeaderBarBreadcrumbs>
                    <React.Suspense fallback={<BreadcrumbsSkeleton items={3} />}>
                        <BreadcrumbsRevision
                            screen={screen}
                            space={space}
                            changeRequest={changeRequest}
                        />
                    </React.Suspense>
                </HeaderBarBreadcrumbs>

                <HeaderBarTabs>
                    <ViewModeButton screen={screen} space={space} changeRequest={changeRequest} />
                </HeaderBarTabs>
            </HeaderBarMain>
        </HeaderBar>
    );
}
